import { curry } from '@fxts/core';

/**
 * input에 0을 채워주는 함수
 *
 * @param total_length 0을 채워서 만들고 싶은 총 길이
 *
 *
 * @example
 * ```ts
 * zeroPad(3, '5'); // '005'
 * zeroPad(2, 5); // '05'
 * zeroPad(1, 5); // '5'
 * ```
 */
export const zeroPad = curry(<T extends number | string>(total_length: number, input: T): string => {
  return String(input).padStart(total_length, '0');
});
